import React, { Component } from 'react';
import Table from '../components/failures/Efects/Index'
import WebpackerReact from 'webpacker-react';

class EfectIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update — mergea el registro completo (incluye participant_ids, responsable, etc.)
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => (
                format.id === item.id ? { ...item, ...format } : item
            ))
        });
    }

    loadData = () => {
        fetch(`/failure/get_efects`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    estados={this.props.estados}

                    users={this.props.users}
                    procesos={this.props.procesos}
                />
            </React.Fragment>
        );
    }
}


export default EfectIndex;
WebpackerReact.setup({ EfectIndex });
